import './add';
import './artist';
import './expire';
import './cards';
import './notification-prefs';
import './update';
import './artists.service.js';
import './artists.component.js';
import './artists.controller.js';
import './_artists.styles.scss';

angular.module('inkfinder').config(function($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.artists', {
    url: '/artists',
    views: {
      '@': {
        component: 'inkArtists'
      }
    },
    resolve: {
      $title: () => 'Your artist network',
      artists: function(Artists) {
        return Artists.refreshArtists().then(function(artists) {
          return artists;
        });
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.operator]
    }
  });
});



// WEBPACK FOOTER //
// ./components/artists/index.js